import pagesInterface from "./pagesInterface";
import carousel from "./pagesInterface/carousel";
import recommendAnExchange from "./pagesInterface/recommendAnExchange";
import investmentDashboard from "./pagesInterface/investmentDashboard";
import investmentOptionDetails from "./pagesInterface/investmentOptionDetails";
import exchangeActivity from "./pagesInterface/exchangeActivity";
import recommendGrant from "./pagesInterface/recommendGrant";
import grantAgreements from "./pagesInterface/grantAgreement";
import grantsActivity from './pagesInterface/grantsActivity';
import myAccount from "./pagesInterface/myAccount";
import needAssistance from "./pagesInterface/needAssistance";
import openAdditonalPhilanthropicAccount from "./pagesInterface/openAdditonalPhilanthropicAccount";
import adminSearchResult from "./pagesInterface/adminSearchResult";
import documentCentre from "./pagesInterface/documentCentre";
import contributionActivity from "./pagesInterface/contributionActivity";
import contributionsDashboard from "./pagesInterface/contributionsDashboard";
import exchanges from './pagesInterface/exchanges';
import howItWorks from "./pagesInterface/howItWorks";
import grantsDashboard from "./pagesInterface/grantsDashboard";
import suggestACharity from './pagesInterface/suggestACharity';
import financialAdvisorDashboard from './pagesInterface/financialAdvisorDashboard';
import makeAContribution from './pagesInterface/makeAContribution';

export default {
  init(opts) {
    const client = pagesInterface.init(opts);
    return {
      carousel: carousel.init(client),
      exchangeActivity: exchangeActivity.init(client),
      grantsActivity: grantsActivity.init(client),
      exchanges: exchangeActivity.init(client),
      recommendAnExchange: recommendAnExchange.init(client),
      investmentDashboard: investmentDashboard.init(client),
      investmentOptionDetails: investmentOptionDetails.init(client),
      recommendGrant: recommendGrant.init(client),
      grantAgreements: grantAgreements.init(client),
      myAccount: myAccount.init(client),
      needAssistance: needAssistance.init(client),
      openAdditonalPhilanthropicAccount: openAdditonalPhilanthropicAccount.init(client),
      adminSearchResult: adminSearchResult.init(client),
      documentCentre: documentCentre.init(client),
      contributionActivity: contributionActivity.init(client),
      financialAdvisorDashboard: financialAdvisorDashboard.init(client),
      contributionsDashboard: contributionsDashboard.init(client),
      howItWorks: howItWorks.init(client),
      grantsDashboard: grantsDashboard.init(client),
      suggestACharity: suggestACharity.init(client),
      makeAContribution:makeAContribution.init(client)
    };
  },
};
